class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;
  isUpdating = false;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

onCartUpdate() {
  if (this.tagName === 'CART-DRAWER-ITEMS') {
    // Cart drawer — existing logic works fine, keep as-is
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  } else {
    // Cart page — fetch full cart state and re-render ALL sections
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    return fetch(`${routes.cart_url}`, { ...fetchConfig(), ...{ body }, method: 'POST' })
      .then((response) => response.json())
      .then((parsedState) => {
        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) ||
            document.getElementById(section.id);
          if (elementToReplace && parsedState.sections[section.section]) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        // Re-init upsell slider after section re-render
        let $slider = $('.wrap_upsell');
        if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');
        $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
          let i = (currentSlide ? currentSlide : 0) + 1;
          $('.counter_upsell').text(i + '/' + slick.slideCount);
        });
        $slider.slick({ arrows: false, dots: false, infinite: true, speed: 800, fade: true, cssEase: 'linear' });
        $('.previous_btn_upsell').on('click', function () { $slider.slick('slickPrev'); });
        $('.next_btn_upsell').on('click', function () { $slider.slick('slickNext'); });
        $('.cuurent_select_op').on('change', function () {
          let selected = $(this).find('option:selected');
          $(`#variant__price__${selected.attr('Pid')}`).text(selected.attr('price'));
        });

        this.updateBulletinBoard();
        this.updateProgressBar();
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.cart_main_wrap',
      },
      {
        id: 'header-progressbar',
        section: 'header-progressbar',
      },
      {
        id: 'cust-bulletin-board',
        section: 'cust-bulletin-board',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

      updateBulletinBoard(){
          const sectionId = $('#cust-bulletin-board').data('section-id');
          $.ajax({
            url: window.location.pathname + '?section_id=' + sectionId,
            type: 'GET',
            dataType: 'html',
            success: function(sectionHtml){
              const content = $(sectionHtml).find('#cust-bulletin-board').html();
              $('#cust-bulletin-board').html(content);
            }
          });
      }

  updateProgressBar(){
    $.ajax({
                      url: '/?section_id=header-progressbar',
                      type: 'GET',
                      dataType: 'html',
                      success: function(sectionHtml){
                          $('#header-progressbar').html($(sectionHtml));
                      }
                    })
  }

  updateQuantity(line, quantity, event, name, variantId) {
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
    const cartPerformanceUpdateMarker = CartPerformance.createStartingMarker(`${eventTarget}:user-action`);
    
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
           
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
          
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          this.updateBulletinBoard(); 
          this.updateProgressBar();
          let firstRun = false;
          this.getSectionsToRender().forEach((section) => {
            
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
                 let $slider = $('.wrap_upsell');
                 if ($slider.hasClass('slick-initialized')) {
                    $slider.slick('unslick'); 
                  }
                  $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
                      let i = (currentSlide ? currentSlide : 0) + 1;
                      $('.counter_upsell').text(i + '/' + slick.slideCount);
                  });
                  $slider.slick({
                      arrows: false,
                      dots: false,
                      infinite: true,
                      speed: 800,
                      fade: true,
                      cssEase: 'linear',
                  });
                  $('.previous_btn_upsell').on('click', function () {
                    $slider.slick('slickPrev');
                  });
                  $('.next_btn_upsell').on('click', function () {
                    $slider.slick('slickNext');
                  });
                $(function () {
                  $('.cuurent_select_op').on('change', function () {
                      let selected = $(this).find('option:selected');
                      let price = selected.attr('price');
                      let pid = selected.attr('Pid');
                    $(`#variant__price__${pid}`).text(price);
                  });
              });
              if(firstRun == false){
              FreeGiftManager.sync(parsedState);
              firstRun = true;  
            }
          });
                      
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });
        
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if(errors){
        errors.textContent = window.cartStrings.error;
        }
      })
      .finally(() => {
        this.disableLoading(line);
        CartPerformance.measureFromMarker(`${eventTarget}:user-action`, cartPerformanceUpdateMarker);
      }); 
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    if(this.lineItemStatusElement){
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then(() =>
              CartPerformance.measureFromEvent('note-update:user-action', event)
            );
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Free Gift Product
class FreeGiftManager {
  
  static sync(parsedState) {
    window.discountSettings.cartTotal = parsedState.items_subtotal_price; 
    let includeVariant = false;
    let giftKey = "";
    let isGift = false;
    window.discountSettings.isGiftpresent = false
    const alreadyInCart = parsedState.items.some(
      (item) => item.variant_id === window.discountSettings.giftProduct
    );
    parsedState.items.forEach(item => {
      if(window.discountSettings.variantsList.indexOf(item.id) > -1){
        includeVariant = true
      }
      if(item.properties["_isGift"] == "Yes"){
        isGift = true;
      }
      if(item.id == window.discountSettings.giftProduct){
        giftKey = item.key
        window.discountSettings.isGiftpresent = true
        window.discountSettings.cartTotal = window.discountSettings.cartTotal - item.final_line_price
      }
    })
    if(!alreadyInCart){
      includeVariant = true
    }
    if(window.discountSettings.enable ){
        if ( includeVariant && window.discountSettings.cartTotal >= window.discountSettings.minimumCartAmount && window.discountSettings.isGiftpresent == false) {
              fetch(window.Shopify.routes.root + 'cart.js')
                .then((res) => res.json())
                .then((cart) => {
                  return fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      items: [
                        {
                          id: window.discountSettings.giftProduct,
                          quantity: 1,
                          properties: { _isGift: 'Yes' },
                        },
                      ],
                    }),
                  });
                })
                .then((res) => res && res.json())
                .then(() => {
                  window.discountSettings.isGiftpresent = true;
                  setTimeout(() => {
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
                  }, 300);
                })
                .catch((err) => {
                  console.error('Gift add failed:', err);
                })
          }else if(isGift){
                            if(!includeVariant || window.discountSettings.cartTotal < window.discountSettings.minimumCartAmount){
                              window.discountSettings.isGiftpresent = false;
                              var formRemoveData = {"id": giftKey, "quantity": 0};
                              $.post({
                                url: theme.routes.cart_change_url + '.js',
                                data: JSON.stringify(formRemoveData),
                                contentType: 'application/json',
                                dataType: 'json'
                              })
                              .done((itemData) => {
                                  setTimeout(() => {
                                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
                                    const sectionId = $('#cust-bulletin-board').data('section-id');
                                          $.ajax({
                                            url: window.location.pathname + '?section_id=' + sectionId,
                                            type: 'GET',
                                            dataType: 'html',
                                            success: function(sectionHtml){
                                              const content = $(sectionHtml).find('#cust-bulletin-board').html();
                                              $('#cust-bulletin-board').html(content);
                                            }
                                          });
                                  }, 300);
                              })
                            }
          }
      }
}
}
// Check free gift on initial page load
document.addEventListener('DOMContentLoaded', () => {
  fetch(window.Shopify.routes?.root + 'cart.js')
    .then((res) => res.json())
    .then((cartState) => FreeGiftManager.sync(cartState))
    .catch((e) => console.error('[FreeGift] Initial check failed:', e));
});
